export default __webpack_public_path__ + "static/media/sweet_earth_header.0e42f204.jpg";